import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { LinkedProcesses } from '@core/entities/linkedProcesses'
import {
  checklistKeys,
  RequestTypes,
} from '@core/react-query/features/checklists/checklist'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const checklistLinkedProcessTransform = (data: LinkedProcesses) => {
  return LinkedProcesses.new(data)
}

export const useGetChecklistLinkedProcesses = (
  payload: RequestTypes['getChecklistLinkedProcesses'],
  options?: UseQueryOptions<LinkedProcesses, RequestErrorType>,
) => {
  return useQuery({
    select: checklistLinkedProcessTransform,
    ...checklistKeys.byId(payload)._ctx.linkedProcesses,
    ...options,
  })
}
